export const InternPlanFormFormat = function (blueprint, form_data = {}) {
  return {
    header_sq: header(form_data),
    content_sq: page(blueprint, form_data),
  };
}
function header(form_data) {
  return [
    {
      w: '100%', h: 50, text: '國立臺灣科技大學學生校外實習學習計畫表',
      border_width: 0, font_size: 21, font_family: '標楷體',
    },
  ];
}

function page(blueprint, form_data) {
  return [
    {
      w: '100%', h: 30, text: '一、基本資料',
      border_width: 0, align: 'left', font_family: '標楷體',
    },

    { w: '18%', h: 30, text: '就讀系/所' },
    { w: '32%', h: 30, text: form_data.department_id },
    { w: '14%', h: 30, text: '學號' },
    { w: '36#', h: 30, text: form_data.student_account },

    { w: '18%', h: 30, text: '姓名' },
    { w: '32%', h: 30, text: form_data.student_name },
    { w: '14%', h: 30, text: '實習單位' },
    { w: '36#', h: 30, text: form_data.internship },

    { w: '18%', h: 30, text: '實習期間' },
    { w: '82%', h: 30, text: `自 ${date_to_str(form_data.intern_start_time)} 起至 ${date_to_str(form_data.intern_end_time)} 止` },

    { w: '18%', h: 50, text: '學校輔導教師' },
    { w: '32%', h: 50, text: form_data.school_teacher },
    { w: '14%', h: 50, text: '實習單位\n輔導教師' },
    { w: '36%', h: 50, text: form_data.intern_teacher },

    {
      w: '100%', h: 30, text: '二、實習學習內容',
      border_width: 0, align: 'left', font_family: '標楷體',
    },

    { w: '7%', h: 340, padding: 5, text: '實習課程目標' },
    {
      w: '92.99%', h: 340, texts: [
        '(依系科課程發展結果及系科專業領域性質，撰寫開設實習課程之目標，可自行增加)', '\n',
        ...(form_data.intern_target || []), '\n',
        other_str(form_data.intern_target_other),
      ],
      line_height: 1.5, padding: 10 , align: 'left'
    },

    ...intern_content_plan_sq(form_data.intern_content_plan),

    { w: '7%', h: 635, padding: 10, text: '實習資源投入及輔導' },
    { w: '15%', h: 235, text: '實習單位提供實習指導與\n資源說明' },
    { w: '78%', h: 235, padding: 10, align: 'left', texts: [
      '實習單位提供實習學生的整體培訓規劃(可複選)', '\n',
      '◎實務基礎訓練：',
      ...form_data.basic_train, '\n',
      other_str(form_data.basic_train_other), '\n',
      '◎實務主題訓練：',
      ...form_data.main_train, '\n',
      other_str(form_data.main_train_other), '\n',
      '實習機構提供資源與設備投入情形(可複選)', '\n',
      ...form_data.resources_invested, '\n',
      other_str(form_data.resources_invested_other),
    ]},

    { w: '15%', h: 210, text: '實習單位輔導教師進行實習輔導形式及\n規劃' },
    { w: '78%', h: 210, padding: 10, align: 'left', texts: [
      '實習單位輔導教師提供的指導內容(可複選)', '\n',
      ...form_data.guide_content, '\n',
      other_str(form_data.guide_content_other), '\n',
      '實習單位輔導教師提供的輔導方式(可複選)', '\n',
      ...form_data.counseling, '\n',
      other_str(form_data.counseling_other),
    ]},

    { w: '15%', h: 190, text: '學校輔導教師進行輔導及\n訪視之具體\n規劃' },
    { w: '78%', h: 190, padding: 10, align: 'left', texts: [
      '學校輔導教師提供輔導內容(可複選)', '\n',
      ...form_data.counseling_content, '\n',
      other_str(form_data.counseling_content_other), '\n',
      '學校輔導教師訪視作業(可複選)', '\n',
      ...form_data.visit, '\n',
      other_str(form_data.visit_other),
    ]},

    {
      w: '100%', h: 30, text: '三、實習成效考核與回饋',
      border_width: 0, align: 'left', font_family: '標楷體',
    },

    { w: '22%', h: 150, padding: 5, text: '實習成效考核指標' },
    { w: '78%', h: 150, padding: 10, align: 'left', texts: [
      '實習單位輔導教師評核 (可複選)', '\n',
      ...form_data.intern_assess, '\n',
      other_str(form_data.intern_assess_other), '\n',
      '學校輔導教師評核(可複選)', '\n',
      ...form_data.school_assess, '\n',
      other_str(form_data.school_assess_other),
    ]},

    { w: '22%', h: 100, padding: 5, text: '實習成效與教學評核方式' },
    { w: '78%', h: 100, padding: 10, align: 'left', texts: [
      '學生實習成果的評核期程', '\n',
      ...form_data.check_assess, '\n',
      '評核人員', '\n',
      ...form_data.check_teacher,
    ]},

    { w: '22%', h: 120, padding: 5, text: '實習回饋方式及規劃\n(可複選)' },
    { w: '78%', h: 120, padding: 10, align: 'left', texts: form_data.intern_feedback},
  ];
}

function intern_content_plan_sq(intern_content_plan) {
  let sq_arr = [];
  for(let f = 10; f<intern_content_plan.length + 20; f += 20) {
    let slice_plan_arr = intern_content_plan.slice(Math.max(0, f - 20), f);
    let slice_sq_arr = intern_content_plan_sq_one(slice_plan_arr);
    sq_arr = sq_arr.concat(slice_sq_arr);
  }
  return sq_arr;
}
function intern_content_plan_sq_one(plan_arr) {
  let sq_arr = plan_arr.map(plan => {
    let time_str = `${date_to_str_yyyy_mm_dd(plan.start_time)} ~\n${date_to_str_yyyy_mm_dd(plan.end_time)}`;
    return [
      { w: '15%', h: 50, align: 'left', padding: 10, text: time_str },
      { w: '30%', h: 50, text: plan.intern_content },
      { w: '48%', h: 50, text: plan.intern_item },
    ];
  });
  return [
    { w: '7%', h: sq_arr.length * 50 + 30, padding: 5, text: '實習課程內容規劃' },
    { w: '15%', h: 30, text: '期間' },
    { w: '30%', h: 30, text: '實習課程內涵' },
    { w: '48%', h: 30, text: '實習具體項目' },
  ].concat(sq_arr.flat());
}

// 通用
function other_str(value) {
  return (value ? '☑': '☐') + ' 其他：' + (value || "____________________");
}
function date_to_str(date_str) {
  if(!date_str) return ' - ';
  let nd = new Date(date_str);
  return `${nd.getFullYear() - 1911} 年 ${nd.getMonth() + 1} 月 ${nd.getDate()} 日`;
}
function date_to_str_yyyy_mm_dd(date_str) {
  if(!date_str) return ' - ';
  let nd = new Date(date_str);
  return [
    nd.getFullYear(),
    ("0" + (nd.getMonth() + 1)).substr(-2),
    ("0" + nd.getDate()).substr(-2),
  ].join('/');
}